<script setup lang="ts">

import { faArrowUpArrowDown } from '@fortawesome/pro-regular-svg-icons'

import { FiltersBar } from '@shared/ui/filters'
import { AppInput } from '@shared/ui/inputs'
import { MultiSelectSearchable, NativeSelect } from '@shared/ui/fields'

import { useTutorKanbanFilters } from '../model/tutor-kanban-filters.hook'

defineOptions({
  name: 'TutorKanbanFilters',
})

const {
  filterResetKey,
  searchQuery,
  categoryOptions,
  categoryInitialValue,
  handleCategorySelected,
  strictCategoryOptions,
  strictCategoryValue,
  handleStrictCategoryChange,
  paidLabelOptions,
  paidLabelInitialValue,
  handlePaidLabelSelected,
  agentsOptions,
  agentsInitialValue,
  handleAgentsSelected,
  reasonsOptions,
  reasonsInitialValue,
  handleReasonsSelected,
  sortOptions,
  sortValue,
  handleSortChange,
  handleSearch,
  handleClear,
} = useTutorKanbanFilters()
</script>

<template>
  <FiltersBar
    class="tkb-filters"
    @click:submit="handleSearch"
    @click:clear="handleClear"
  >
    <template #fields>
      <div
        :key="filterResetKey"
        class="tkb-filters__general"
      >
        <AppInput
          v-model="searchQuery"
          label="Search"
          placeholder="Search"
        />
        <MultiSelectSearchable
          :key="categoryOptions.length"
          class="multiselect-category"
          label="Category"
          placeholder="All"
          :options="categoryOptions"
          :value="categoryInitialValue"
          :is-all-available="true"
          @selected="handleCategorySelected"
        />
        <NativeSelect
          class="strict-select"
          label="Strict Category"
          name="strict-select"
          :options="strictCategoryOptions"
          :value="strictCategoryValue"
          @change="handleStrictCategoryChange"
        />
        <MultiSelectSearchable
          :key="paidLabelOptions.length"
          class="multiselect-paid-label"
          label="Paid Label"
          placeholder="All"
          :options="paidLabelOptions"
          :value="paidLabelInitialValue"
          :is-all-available="true"
          @selected="handlePaidLabelSelected"
        />
        <MultiSelectSearchable
          :key="agentsOptions.length"
          class="multiselect-agents"
          label="Agent"
          placeholder="All"
          :options="agentsOptions"
          :value="agentsInitialValue"
          :is-all-available="true"
          @selected="handleAgentsSelected"
        />
        <MultiSelectSearchable
          :key="reasonsOptions.length"
          class="multiselect-reasons"
          label="Stage reason"
          placeholder="All"
          :options="reasonsOptions"
          :value="reasonsInitialValue"
          :is-all-available="true"
          @selected="handleReasonsSelected"
        />
        <NativeSelect
          class="sort-select"
          label="Sort"
          name="sort-select"
          :icon="faArrowUpArrowDown"
          :options="sortOptions"
          :value="sortValue"
          @change="handleSortChange"
        />
      </div>
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./TutorKanbanFilters.scss" />
